import { Button, FormControl, Grid, InputLabel, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";

import { MenuItem } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { useHistory, useParams } from "react-router-dom";

// import { getLogisticStopsData } from "../../actions/LogisticsPanelAction";
// import { generateStopsFilter } from "../../../helpers/generateUrl";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },
        contentHeader: {
            width: "100%",
            padding: "0px 10px 40px 10px",
            minHeight: "64px",
        },
        leftContentHeader: {
            width: "50%",
            float: "left",
        },
        rightContentHeader: {
            width: "50%",
            float: "right",
            textAlign: "right",
            paddingRight: "20px",
        },
        buttonContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        head: {
            textAlign: "center",
            fontWeight: "normal",
            marginBottom: "2rem",
        },
        slotContainer: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
        },
        slot: {
            width: "150px",
            height: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            margin: "0.5rem",
        },
        hoveItem: {
            cursor: "pointer",
        },
        selectedSlot: {
            width: "150px",
            height: "100px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
            cursor: "pointer",
            margin: "0.5rem",
        },
        chips: {
            display: "flex",
        },
        chip: {
            margin: 2,
            background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
            maxWidth: "130px",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        contentTable: {
            width: "100%",
            padding: "20px 10px 10px 10px",
            background: "#ffffff",
            margin: "10px",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#924A91",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    getCities: any;
    cities: any;
    loading: any;
}
const StopsPlace: React.FC<Props> = ({
    getCities,
    cities,
    loading,
}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [clientEmail, setClientEmail] = React.useState<any>("");
    const [longitude, setLongitude] = React.useState<any>("");
    const [client, setClient] = React.useState<any>("");
    const [libraries, setLibraries] = useState<any>("");
    const [clientMobile, setClientMobile] = useState<any>("");
    const [subProject, setSubProject] = useState<any>("");
    const [project, setProject] = useState<any>("");
    const [sampleId, setSampleId] = useState<any>("");
    const [platforms, setPlatforms] = useState<any>("");
    const [bdPoint, setBdPoint] = useState<any>("");
    const [sampleRecived, setSampleRecived] = useState<any>("")
    const [isEdit, setIsEdit] = useState<any>(false);
    const [editId, setEditId] = useState<any>("");
    const [samples, setSamples] = useState<any>("");
    const [page, setPage] = useState(0);
    const [passSample, setPassSample] = useState<any>("");
    const { id } = useParams<{ id: string }>();
    const [requirement, setRequiredment] = useState<any>([]);
    const [validFrom, setVadilFrom] = useState<any>("");
    const [applications, setApplications] = useState<any>("");
    const [projectId, setProjectId] = useState<any>("");
    const [sif, setSif] = useState<boolean>(true);
    const [leakage, setLeakage] = useState<boolean>(false);
    const [openLeadModal, setOpenLeadModal] = useState<any>(false);
    const [openLeadModalFlag, setOpenLeadModalFlag] = useState<any>(false);
    const [poStatus, setPoStatus] = useState<boolean>(true);
    const [storage, setStorage] = useState<boolean>(true);
    const [bioRequired, setBioRequired] = useState<boolean>(true);
    const [projectTitle, setProjectTitle] = useState<any>("");
    const [file1, setFile1] = React.useState<any>([]);
    const [receipt, setReceipt] = React.useState<any>("");
    const [search, setSearch] = useState<String>("");
    const [sampleStatus, setSampleStatus] = useState<string>("false");
    const [sampleReject, setSampleReject] = useState<string>("false");
    const handleSearch = (e: React.ChangeEvent<{ value: unknown }>) => {
        setSearch(e.target.value as string);
    };
    function inputKeyUp(e: any) {
        e.which = e.which || e.keyCode;
        if (e.which === 13) {
            searchLead();
        }
    }
    const searchLead = () => {
        let body = {
            search_by: "call_id",
            value: search,
        };

        // getLeads(body, "number=true");
        setOpenLeadModalFlag(true);
    };
    const [stops, setStops] = useState<any>([
        {
            stop: "",
            // name: "",
            time: "",

            panel_users: ""
        },
    ]);
    const fileSelectedHandler1 = (e: React.ChangeEvent<{ files: any }>) => {
        setFile1(e.target.files[0]);
    };
    const fileSelectedHandler2 = (e: React.ChangeEvent<{ files: any }>) => {
        setFile1(e.target.files[0]);
    }; const fileSelectedHandler3 = (e: React.ChangeEvent<{ files: any }>) => {
        setFile1(e.target.files[0]);
    }; const fileSelectedHandler4 = (e: React.ChangeEvent<{ files: any }>) => {
        setFile1(e.target.files[0]);
    };
    const [inputList, setInputList] = useState<any>([
        {
            platforms: "",
            applications: "",
            projectTitle: "",
            samples: "",
        },
    ]);

    const handleInputChange = (index: any, val: any, key: any) => {
        let list = [...inputList];
        if (key === "sampleName" && val !== undefined) {
            list[index]["sampleName"] = val;
        } else if (key === "sample_ID" && val === undefined) {
            delete list[index]["sample_ID"]
        } else if (key === "samples") {
            list[index]["samples"] = val;
        } else if (key === "platforms") {
            list[index]["platforms"] = val;
        } else if (key === "applications") {
            list[index]["applications"] = val;
        }
        setInputList(list);
    };

    const handleRemoveClick = (index: any) => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };
    const handleAddClick = () => {
        setInputList([
            ...inputList,
            {
                platforms: "",
                applications: "",
                projectTitle: "",
                samples: "",

            },
        ]);
    };
    return (
        <Paper style={{ margin: "70px auto", width: "80%", background: "#eff" }}>
            <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Billings & Project Closed </h2>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="flex-end"
                spacing={2}
                style={{ margin: "1rem auto" }}
            >
                <Grid item xs={12} sm={4} >
                    <TextField
                        label="Billing Date"
                        variant="outlined"
                        className="input"
                        type="date"
                        fullWidth
                        value={projectTitle}
                        onChange={(e) => setProjectTitle(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl style={{ width: "100%" }} className="input">
                        <InputLabel>Billing Completed</InputLabel>
                        <Select
                            label="Billing Completed"
                            variant="outlined"
                            className="input"
                            fullWidth
                            value={sampleId}
                            style={{ width: "100%", height: "40px" }}
                            onChange={(e) => setSampleId(e.target.value)}
                        >
                            <MenuItem value="true">Yes</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl style={{ width: "100%" }} className="input">
                    <InputLabel>Upload pdf</InputLabel>
                        <sup
                            style={{
                                fontSize: "11px",
                                marginLeft: "15px",
                                marginTop: "15px",
                                background: "#fff",
                                color: "rgba(0, 0, 0, 0.54)",
                                letterSpacing: "0.00938em",
                            }}
                        >
                        </sup>
                        <input
                            className={classes.input}
                            style={{
                                width: "100%",
                                marginTop: "-15px",
                                padding: "11.5px 14px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "5px",
                            }}
                            type="file"
                            name="file"
                            id="file"
                            multiple
                            onChange={fileSelectedHandler2}
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid xs={6} style={{ textAlign: "center", padding: "20px" }}>
                <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    style={{ width: 300 }}

                >
                    {isEdit ? "update" : "Close Project"}
                </Button>
            </Grid>
            {/* <Grid item xs={6} style={{ textAlign: "center", padding: "20px" }}>
                        <Button
                            color="secondary"
                            variant="contained"
                            style={{ width:100 }}
                        >
                            reset
                        </Button>
                    </Grid> */}
        </Paper>
    );
};
const mapStateToProps = (state: any) => ({

});
export default connect(mapStateToProps, {

})(StopsPlace);
